/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import { UsbBaseService } from '../../shared/services/usb-base.service';
import { Store } from '@ngrx/store';
import { selectRtiAttached } from '../../+state/usb.selectors';
import { filter, take } from 'rxjs/operators';
import { RtiAudioService } from './rti-audio.service';
import { selectRtiProfile } from '../../../configuration/+state/configuration.selectors';
import { Report1 } from '../../shared/model/report-1/report-1';
import { enforceHeadsetPresence, rtiInitialized } from '../../+state/usb.actions';
import { VolumeMessage } from '../../shared/model/report-1/control/volume-message';
import { RtiConfiguration } from '../../../cad-config/model/console-position';

@Injectable({ providedIn: 'root' })
export class RTIService extends UsbBaseService {
    public initializedAction = rtiInitialized();

    public readonly DEVICE_NAME = 'RTI';
    public readonly VENDOR_ID = 0x1694;
    public readonly PRODUCT_ID = 0x0010;

    constructor(protected store: Store, private audioService: RtiAudioService) {
        super(store);
        this.store
            .select(selectRtiAttached)
            .pipe(
                filter((val) => val),
                take(1)
            )
            .subscribe(() => {
                this.init();
                this.audioService.init();
            });
        this.store
            .select(selectRtiProfile)
            .pipe(filter((profile: string) => !!profile))
            .subscribe((profile: string) => {
                let parsedProfile: RtiConfiguration = JSON.parse(profile);
                this.store.dispatch(enforceHeadsetPresence({ enforce: parsedProfile.enforceHeadsetPresence }));
                this.configuration$.next(parsedProfile.configuration
                    .map((message) => new Report1(new Uint8Array(message).buffer)));
                this.deviceGains$.next((parsedProfile.deviceGains ?? [])
                    .map((message) => new VolumeMessage(new Uint8Array(message).buffer))
                    .filter((message) => Boolean(message.payload2String())));

                if (this.device?.opened) {
                    void this.applyProfileSettings();
                }
            });
    }

}
